const EMPTY_SELECTED = {
  address_type: 0,
  business_number: '',
  company_type_short: '',
  country: '',
  display_details: '',
  eligible_vat6: false,
  id: null,
  master_id: null,
  name: '',
  alias: '',
  place: '',
  status: null,
  street: '',
}

export default ({
  view = 'book',
  kind = 'invoice',
  selected = { ...EMPTY_SELECTED },
  invalid = false,
} = {}) => ({
  view,
  kind,
  selected,
  invalid,
  newModeReady: false,
  newIsCompany: false,

  init() {
    this.$watch('view', () => this.broadcast())
    this.$watch('selected', () => this.broadcast())
    this.$watch('newModeReady', () => this.broadcast())
    this.$watch('newIsCompany', () => this.broadcast())
    this.$nextTick(() => this.broadcast())
  },

  onFieldsChange(detail) {
    this.newModeReady = !!detail.ready
    this.newIsCompany = !!detail.is_company
  },

  onPick(detail) {
    this.invalid = false
    this.selected = {
      address_type: detail.address_type ?? 0,
      business_number: detail.business_number || '',
      company_type_short: detail.company_type_short || '',
      country: detail.country || '',
      display_details: detail.display_details || '',
      eligible_vat6: !!detail.eligible_vat6,
      id: detail.id ?? null,
      master_id: detail.master_id ?? null,
      name: detail.name || '',
      alias: detail.alias || '',
      place: detail.place || '',
      status: detail.status || null,
      street: detail.street || '',
    }
    this.view = 'book'
  },

  clearSelection() {
    this.selected = { ...EMPTY_SELECTED }
  },

  goToForm() {
    this.invalid = false
    this.view = 'form'
  },

  goToBook() {
    this.view = 'book'
  },

  get hasPickedAddress() {
    return !!(this.selected.master_id || this.selected.id)
  },

  get resolvedMasterId() {
    if (this.view !== 'book') return ''
    return this.selected.master_id || ''
  },

  get resolvedAddressId() {
    if (this.view !== 'book') return ''
    if (this.selected.master_id) return ''
    return this.selected.id || ''
  },

  get activeEligible() {
    if (this.view === 'book') return !!this.selected.eligible_vat6
    return false
  },

  get activeIsCompany() {
    if (this.view === 'book') return this.selected.address_type === 1
    if (this.view === 'form') return !!this.newIsCompany
    return false
  },

  get hasSelection() {
    if (this.view === 'form') return this.newModeReady
    return this.hasPickedAddress
  },

  broadcast() {
    this.$dispatch('address-picker:change', {
      kind: this.kind,
      master_id: this.resolvedMasterId,
      address_id: this.resolvedAddressId,
      eligible_vat6: this.activeEligible,
      is_company: this.activeIsCompany,
      has_selection: this.hasSelection,
    })
  },
})
